// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { SetDemoRoleDemoRbacSetRolePostMutationRequest, SetDemoRoleDemoRbacSetRolePostMutationResponse, SetDemoRoleDemoRbacSetRolePost422 } from "../models/demoController/SetDemoRoleDemoRbacSetRolePost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getSetDemoRoleDemoRbacSetRolePostUrl() {
  const res = { method: 'POST', url: `/demo/rbac/set-role` as const }
  return res
}

/**
 * @description Change your role for demo purposes (debug mode only).
 * This allows testing different permission levels without
 * needing actual admin access.
 * @summary Set Demo Role
 * {@link /demo/rbac/set-role}
 */
export async function setDemoRoleDemoRbacSetRolePost(data: SetDemoRoleDemoRbacSetRolePostMutationRequest, config: Partial<RequestConfig<SetDemoRoleDemoRbacSetRolePostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SetDemoRoleDemoRbacSetRolePostMutationResponse, ResponseErrorConfig<SetDemoRoleDemoRbacSetRolePost422>, SetDemoRoleDemoRbacSetRolePostMutationRequest>({ method : "POST", url : getSetDemoRoleDemoRbacSetRolePostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}